// custom-event.service.ts
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface IToggleuserpreferenceInput {
    showToggleSwitch: boolean;
    integrationsUI?: boolean;
    preferenceValue?: any;
    screenName?: string;
    oldUrl?: string;
    newUrl?: string;
    title?: string;
    dragEnabled?: boolean;
}
@Injectable({ providedIn: 'root' })
export class CsToggleuserpreferenceService {
    private eventSubject = new Subject<any>();

    emit(data?: IToggleuserpreferenceInput): void {
        this.eventSubject.next(data);
    }

    onEvent(): Observable<any> {
        return this.eventSubject.asObservable();
    }
}
